var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isImage)?_c('img',{attrs:{"src":_vm.url}}):(_vm.isFont)?_c('span',{class:_vm.cssClass}):_c('span',{staticClass:"icon-placeholder"})
}
var staticRenderFns = []

export { render, staticRenderFns }